import { PessoaProps } from '../types/context';

export const resetPessoa: PessoaProps = {
  cod_pessoa: null,
  num_cpf_cnpj: null,
};
